import { useEffect, useState } from "react"
import { useFetch } from "../../../common/hooks/useFetch"
import { countTasksGroupByStatusService } from "../services/countTasksGroupByStatus.service"

export const useCountTasksGroupByStatusQuery = (filters) => {
  const fetchData = useFetch()
  const [totalTasks, setTotalTasks] = useState({
    completada: 0,
    pendiente: 0
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchTotalTasks = async () => {
      try {
        setLoading(true)
        const response = await countTasksGroupByStatusService(fetchData)(filters)
        setTotalTasks(response)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }

    fetchTotalTasks()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.startDate, filters.endDate])

  return { totalTasks, loading }
}
